// start:ng42.barrel
export * from './editor.component';
export * from './editor.module';
// end:ng42.barrel
